<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="card card-blue">
                    <div class="card-header">
                        <h4 class="card-title">Edit Warehouse</h4>
                        <h6 class="card-subtitle">Please keep your profile information always current in order to help
                            you when you contact us.</h6>
                    </div>
                    <form @submit.prevent="handleSubmit" class="form-horizontal">
                        <div class="card-body">
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="name">
                                    Name
                                </label>
                                <div class="col-sm-6">
                                    <input :class="{'is-invalid': submitted && errors.has('name')}"
                                           class="form-control"
                                           data-vv-as="Name"
                                           id="name"
                                           name="name"
                                           placeholder="Name"
                                           type="text"
                                           v-model="warehouse.name"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('name')">{{
                                        errors.first('name') }}
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="description">
                                    Description
                                </label>
                                <div class="col-sm-6">
                                    <textarea :class="{'is-invalid': submitted && errors.has('description')}"
                                              class="form-control"
                                              data-vv-as="Description"
                                              id="description"
                                              name="description"
                                              placeholder="Description"
                                              type="text"
                                              v-model="warehouse.description"
                                              v-validate="'required'">
                                    </textarea>
                                    <div class="invalid-feedback" v-if="submitted && errors.has('description')">{{
                                        errors.first('description') }}
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label"
                                       for="line1">Address</label>
                                <div class="col-sm-6">
                                    <input :class="{'is-invalid': submitted && errors.has('line1')}"
                                           class="form-control"
                                           data-vv-as="Address Line 1"
                                           id="line1"
                                           name="line1"
                                           placeholder="Address Line 1"
                                           type="text"
                                           v-model="warehouse.address.line1"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('line1')">{{
                                        errors.first('line1') }}
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-sm-6 offset-3">
                                    <input :class="{'is-invalid': submitted && errors.has('line2')}"
                                           class="form-control"
                                           data-vv-as="Address Line 2"
                                           id="line2"
                                           name="line2"
                                           placeholder="Address Line 2"
                                           type="text"
                                           v-model="warehouse.address.line2">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('line2')">{{
                                        errors.first('line2') }}
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="city"></label>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('city')}" class="form-control"
                                           data-vv-as="City"
                                           id="city"
                                           name="city"
                                           placeholder="City"
                                           type="text"
                                           v-model="warehouse.address.city"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('city')">{{
                                        errors.first('city') }}
                                    </div>
                                </div>

                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('state')}"
                                           class="form-control"
                                           data-vv-as="State"
                                           id="state"
                                           name="state"
                                           placeholder="State or Province"
                                           type="text"
                                           v-model="warehouse.address.state"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('state')">{{
                                        errors.first('state') }}
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-sm-3 offset-3">
                                    <input :class="{'is-invalid': submitted && errors.has('postal_code')}"
                                           class="form-control"
                                           data-vv-as="Postal Code"
                                           id="postal_code"
                                           name="postal_code"
                                           placeholder="Postal Code"
                                           type="text"
                                           v-model="warehouse.address.postal_code"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('postal_code')">{{
                                        errors.first('postal_code') }}
                                    </div>
                                </div>

                                <div class="col-sm-3">
                                    <multiselect :class="{'is-invalid': submitted && errors.has('country')}"
                                                 :options="countries"
                                                 class="form-control multiselect-sm"
                                                 data-vv-as="Country"
                                                 id="country"
                                                 label="name"
                                                 name="country"
                                                 placeholder="Country"
                                                 track-by="code"
                                                 v-model="warehouse.address.country"
                                                 v-validate="'required'">
                                    </multiselect>
                                    <div class="invalid-feedback" v-if="submitted && errors.has('country')">{{
                                        errors.first('country') }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card-footer">
                            <div class="form-group m-b-0 text-right">
                                <div class="button-group">
                                    <button class="btn waves-effect waves-light btn-success" type="submit">Save</button>
                                    <button @click="reset" class="btn waves-effect waves-light btn-secondary"
                                            type="button">Reset
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import {mapGetters} from "vuex";
    import uuid from "uuid/v4";
    import axios from "axios";
    import countries from "../../../../../assets/js/countries.json";

    export default {
        name: "Edit",
        components: {Multiselect},
        props: ["warehouseid"],
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                isLoading: false,
                submitted: false,
                countries: countries,
                warehouse: {
                    name: null,
                    description: null,
                    address: {
                        line1: null,
                        line2: null,
                        city: null,
                        state: null,
                        postal_code: null,
                        country: null,
                        country_code: null
                    },
                    attachments: []
                },
                bkp: null
            }
        },
        mounted() {
            this.getWareHouse();
        },
        methods: {
            async getWareHouse() {
                let reply = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/warehouses/${this.warehouseid}`);

                this.bkp = {
                    id: reply.data.id,
                    name: reply.data.name,
                    description: reply.data.description,
                    address: {
                        ...reply.data.address,
                        country: {
                            name: reply.data.address.country,
                            country_code: reply.data.address.country_code
                        },
                        country_code: null
                    }
                }

                this.warehouse = JSON.parse(JSON.stringify(this.bkp));
            },
            async save() {
                try {
                    this.warehouse.attachments = [];
                    this.warehouse.address.country = this.warehouse.address.country.name;
                    await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/warehouses/${this.warehouseid}`, this.warehouse);
                    this.$toastr('success', 'Warehouse updated', 'Success');
                    await this.$router.push({name: "marketplacewarehouses"});
                } catch (e) {
                }
            },
            handleSubmit(e) {
                this.submitted = true;
                this.$validator.validate()
                    .then(valid => {
                        if (valid) {
                            this.save();
                        }
                    });
            },
            handleFileChange(e) {
                this.file = this.$refs.attachment.files[0];
                this.filename = this.file.name;
            },
            async uploadFile() {
                try {
                    let filename = this.file.name;
                    let contenttype = this.file.type.split('/')[1];

                    // get signed url and upload file to s3;

                    let reply = await this.$http.get(`marketplaces/${this.currentOrg.marketplace_id}/partner/signedUrl`, {
                        params:
                            {
                                type: 'write',
                                filename: filename,
                                contenttype: contenttype
                            }
                    });

                    this.partner.attachments.push({
                        id: uuid(),
                        filename: this.filename,
                        title: this.fileTitle,
                        url: reply.data.url,
                        desc: this.fileDesc,
                        filepath: reply.data.key,
                        contenttype: contenttype
                    });

                    await axios.put(reply.data.url, this.file);
                    this.resetAttachment();
                } catch (e) {

                }
            },
            async deleteFile(id, filepath) {
                try {

                    $(".preloader").fadeIn();
                    await this.$http.delete(`/marketplaces/${this.currentOrg.marketplace_id}/partner/attachments`, {
                        data: {
                            filepath: filepath
                        }
                    });
                    _.remove(this.partner.attachments, function (a) {
                        return a.id == id;
                    });
                    this.partner.attachments = JSON.parse(JSON.stringify(this.partner.attachments));
                    $(".preloader").fadeOut();
                    this.$toastr('success', 'Attachment deleted successfully', 'Success');
                } catch (e) {
                    $(".preloader").fadeOut();
                } finally {
                    $(".preloader").fadeOut();
                }
            },
            resetAttachment() {
                this.file = null;
                this.fileTitle = null;
                this.fileDesc = null;
                this.filename = "Upload Attachment";
            },
            reset() {
                this.warehouse = JSON.parse(JSON.stringify(this.bkp));
            }
        }
    }
</script>

<style scoped>
    .mulsel.multiselect__tags {
        min-height: 32px !important;
        padding: 0px 40px 0 8px !important;
    }
</style>
